import { render, staticRenderFns } from "./FormW8BEN.vue?vue&type=template&id=5d6ad018&"
import script from "./FormW8BEN.vue?vue&type=script&lang=ts&"
export * from "./FormW8BEN.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports